<template lang="pug">
  .url_tracker
</template>

<script>
import Cookies from "js-cookie";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("global");

export default {
  name: "RegistrationUrlTracker",

  data() {
    return {
      cookie_name: "registration_url",
      cookie_hours: 1,
    };
  },

  computed: {
    ...mapGetters(["isUserNotAuthed", "isUserAuthedNotRegistered", "isUserProcessed"]),
  },

  watch: {
    isUserProcessed() {
      if (this.isUserNotAuthed || this.isUserAuthedNotRegistered) {
        this.setCookie();
      }
    },
  },

  mounted() {
    if (this.isUserProcessed && (this.isUserNotAuthed || this.isUserAuthedNotRegistered)) {
      this.setCookie();
    }

    window.addEventListener("hashchange", this.setCookie);
  },

  methods: {
    setCookie() {
      const expires_in = new Date(new Date().getTime() + this.cookie_hours * 60 * 60 * 1000);
      const cookie_host = window.location.host;
      const cookie_value = window.location.href;

      Cookies.set(this.cookie_name, cookie_value, {
        path: "/",
        domain: cookie_host,
        expires: expires_in,
      });
    },
  },
};
</script>

<style>
.url_tracker {
  display: none;
}
</style>
